import format from 'date-fns/format'

const getFrequencyDisplay = (startDate, frequency) => {
  try {
    if (!startDate) {
      return ''
    }

    if (frequency === 'monthly') {
      return `Every month on the ${format(startDate, 'do')}`
    }

    if (frequency === 'quarterly') {
      return `On the ${format(startDate, 'do')}, every three months`
    }

    if (frequency === 'annually') {
      return `Every year, on ${format(startDate, 'MM/dd')}`
    }

    return startDate.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
  } catch (error) {
    return ''
  }
}

export default getFrequencyDisplay
